import React, { useState } from "react";
import { Modal, Upload, Button, message, Image } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../../Config";

const PromotionPopup = ({ open, onClose, variation }) => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= HANDLE UPLOAD ================= */
  const handleChange = ({ fileList }) => {
    setFileList(fileList);
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    if (!fileList.length) {
      return message.warning("Please upload at least one image");
    }

    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");

      const formData = new FormData();
      formData.append("variationId", variation._id);

      fileList.forEach((file) => {
        formData.append("PromoteImages", file.originFileObj);
      });

      await axios.post(`${BASE_URL}/promoteimgs`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("Promotion images uploaded successfully");
      setFileList([]);
      onClose();
    } catch (err) {
      message.error("Failed to upload images");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Promote Your Variation"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
    >
      {/* ================= IMAGE UPLOADER ================= */}
      <Upload
        listType="picture-card"
        multiple
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={() => false} // ❗ prevents auto upload
      >
        {fileList.length < 10 && (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>

      {/* ================= ACTIONS ================= */}
      <div style={{ textAlign: "right", marginTop: 20 }}>
        <Button onClick={onClose} style={{ marginRight: 10 }}>
          Cancel
        </Button>
        <Button type="primary" loading={loading} onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default PromotionPopup;
